import React from 'react';

import useHttpIncidentExport from 'features/http/model/useHttpIncidentExport';

import HttpIncidentFiltersForm from '../HttpIncidentFilters/HttpIncidentFiltersForm';
import HttpIncidentsExportResult from './HttpIncidentsExportResult';

interface IHttpIncidentExportFormHandlerProps {
    handleClose: () => void,
}
const HttpIncidentExportFormHandler: React.FC<IHttpIncidentExportFormHandlerProps> = ({handleClose}) => {
    const {result, isLoading, progress, onSubmit, handleCloseResult} = useHttpIncidentExport(handleClose);

    return (
        <>
            {
                result
                    ? <HttpIncidentsExportResult
                        result={result}
                        handleClose={handleCloseResult}
                    />
                    : <HttpIncidentFiltersForm
                        onSubmit={onSubmit}
                        onClose={handleClose}
                        ixExport={true}
                        isLoading={isLoading}
                        progress={progress}
                    />
            }
        </>
    );
};

export default HttpIncidentExportFormHandler;
